"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardStopCTOCms = void 0;
var HardStopCTOCms = /** @class */ (function () {
    function HardStopCTOCms() {
        this.ctoHeadingLabel = 'You already have service with us';
        this.ctoDescriptionOneTxt = 'As a current customer, you\'ll need to sign in to your account to '
            + 'make changes to your service.';
        this.ctoDescriptionTwoTxt = 'Please call us at <span class=\'phoneNumber\'>8xx.xxx.xxxx</span>.';
        this.ctoManageServiceButtonLabel = 'Manage my service';
        this.ctoManageServiceUrl = 'https://www.att.com/shop/login/login.html?wlsfi=MODIFY';
        this.ctoPersistErrorTxt = 'Unable to persist contact info at this moment. Please try again.';
        this.ctoDescriptionBsseFlow = 'Please call us at 877.320.3146, so we can help with your order';
    }
    return HardStopCTOCms;
}());
exports.HardStopCTOCms = HardStopCTOCms;
//# sourceMappingURL=hardstopcto.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/hardstopcto.cms.js
// module id = 1984
// module chunks = 8